
















































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import ReturnHandle from '@/views/back/logistics/return-handle.vue'
import ExpressCostHandle from '@/views/back/logistics/expresscost-deducted.vue'
import ProcessFailure from '@/views/back/logistics/rejection-process-failure.vue'
import AddRemark from '@/views/back/logistics/returnreject-addremark.vue'
import storeaddressInfo from '@/store/entities/back-storeaddress-list'
import Enums from '@/lib/enums'
import { routers } from '@/router/router'
import DateUtils from '@/common/js/DateUtils'
import Preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import appconst from '@/lib/appconst';
Vue.use(Preview);
import VueClipboard from 'vue-clipboard2'
import { classPrintWorld } from '@/common/js/PrintWorld'
import { Select } from '../../../types/iview/select';
import moment from 'moment'
Vue.use(VueClipboard)

class PagebackoverseasreturnhandleRequest extends PageRequest {
    shipment: string;
    beginTime?: Date;
    endTime?: Date;
    deductionBeginTime?: Date;
    deductionEndTime?: Date;
    returnNo: string;
    handleType?: number;
    handleStatus?: number;
    deductionType?: number;
    whetherArriveWarehouse?: boolean;
    orderType?: number;
    userName: string;
    constructor() {
        super();
        this.deductionType = null;
        this.handleType = null;
        this.handleStatus = null;
    
    }
}

@Component
    ({
        name: "backoverseasreturnhandle",
        components: { ReturnHandle, ProcessFailure, ExpressCostHandle, AddRemark}
    })
export default class backoverseasreturnhandle extends AbpBase {
    handleStatus = Enums.getEnum(Enums.HandleStatus, true);
    handleType = Enums.getEnum(Enums.HandleType, true);
    //orderTypeStatus = Enums.getEnum(Enums.WarehouseOrderType, true);
    deductionType = Enums.getEnum(Enums.DeductionType, true);
    pagerequest: PagebackoverseasreturnhandleRequest = new PagebackoverseasreturnhandleRequest();
    returnHandleModalShow: boolean = false;
    expressCostHandleModalShow: boolean = false;
    processFailureModalShow: boolean = false;
    addRemarkModalShow: boolean = false;
    isDisplay: boolean = true;
    isLoadPrintList: boolean = false;
    ids: string = "";
    whetherStatus = Enums.getEnum(Enums.WhetherArriveWarehouseStatus, true);
    creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
    deductionTime: Date[] = [];
    storeaddressList: Array<storeaddressInfo> = [];
    //revokedTime: Date[] = [];
    //rejectionTime: Date[] = [];
    get list() {
        var a = this.hasPermission("OrderManage.MainLandOrderManage");
        var b = this.hasPermission("OrderManage.MainLandOrderManage.FreightCost");
        if (a == true && b == false) {

            this.isDisplay = false;
            return this.$store.state.backoverseasreturnhandle.list.filter(function (item) { return item.orderType == 1 });

        }
        else {
            return this.$store.state.backoverseasreturnhandle.list;
        }

    };
    get loading() {
        return this.$store.state.backoverseasreturnhandle.loading;
    }
    async searchPage() {
        this.$store.state.backoverseasreturnhandle.currentPage = 1;
        this.getpage();
    }

    async exportexpress() {
        await this.$store.dispatch({
            type: 'backoverseasreturnhandle/impotExcel',
            data: { BeginTime: this.pagerequest.beginTime, EndTime: this.pagerequest.endTime, Ids: "" }
        })
    }
    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        var a = new storeaddressInfo();
        a.id = null;
        a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        if (abp.session.userId == 218 || abp.session.userId == 198) {

        }
        else {
            this.storeaddressList.push(a);
        }

    }

    async exportselect() {
        var selectionData: any = this.$refs.selection;
        var selection = selectionData.getSelection();
        if (!selection || selection.length == 0) {
            this.$Message.error("选中项不能为空！");
            return;
        }

        for (var i = 0; i < selection.length; i++) {
            this.ids += selection[i].id + ",";
        }
        await this.$store.dispatch({
            type: 'backoverseasreturnhandle/SelectedExportExcel',
            data: { BeginTime: this.pagerequest.beginTime, EndTime: this.pagerequest.endTime, ids: this.ids }
        })

        //await this.$store.dispatch({
        //    type: 'backorder/updatePackageStatus',
        //    data: { ids: ids, PackageStatus: statu, orderType: this.pagerequest.OrderType }
        //});
        //await this.$store.dispatch({
        //    type: 'backoverseasreturnhandle/impotExcel',
        //    data: { BeginTime: this.pagerequest.beginTime, EndTime: this.pagerequest.endTime }
        //})
    }
    pageChange(page: number) {
        this.$store.commit('backoverseasreturnhandle/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('backoverseasreturnhandle/setPageSize', pagesize);
        this.getpage();
    }
    async Txm(data: any) {
        this.$store.commit('fontorder/getPdfbyte', {
            barCode:"",
            shelfPosition: "",
            imageUrl: data.imageGuid
        });
    }

    async printingImage(data: any) {
        if (!this.isLoadPrintList) {
            var printWorld = new classPrintWorld(); //new一个打天下对象。不提供URL参数，意为本机的打天下打印服务器（"http://127.0.0.1:8888"）。
            var json = {
                action: "", refresh: true, defaultprn: true, error: "", val: {}
            };
            json.action = "printers";
            json.refresh = true;                      //为true，则可确保返回刚刚添加的打印机。
            json.defaultprn = true;                   //是否包含缺省打印机信息。
            json = printWorld.Direct(json);
            if (json == null) {//数据发送失败
                alert(printWorld.GetLastError());
            } else if (json.error != undefined) {   //打天下打印服务返回的错误信息
                alert(json.error);
            } else {    //处理包含打印机列表的json
            }
            for (var i in json.val) {
                var option = document.createElement('option');
                option.innerHTML = json.val[i].name;
                option.value = json.val[i].name;
                document.getElementById('SelectPrint').appendChild(option);
            }
            this.isLoadPrintList = true;
            this.$Message.success("已加载打印机，请选择指定打印机");
            return;
        }

        var pdfData = {
            barCode: "",
            shelfPosition: "",
            imageUrl: data.imageGuid,
            url: '',
        };
        this.$store.commit('fontorder/getPdfUrl', pdfData);
        var printSelect: any = document.querySelector('#SelectPrint');
        if (!printSelect.value) {
            this.$Message.success("请选择指定打印机");                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
            return;
        }

        if (pdfData.url && pdfData.url.length > 0) {
            var jsonsList = [];
            var printWorld = new classPrintWorld(); //new 一个打天下对象
                var jsons = { action: "", format: "", content: "", printer: "", cert: "", paperlength: 0, paperwidth: 0 };
                jsons.action = "printfile";
                jsons.format = "pdf_url";        //指定格式为pdf_url。
                jsons.content = pdfData.url;   //pdf文件的url路径
                jsons.paperlength = 15;
                jsons.paperwidth = 10;
                jsons.cert = "https://tkyc.ddtmx.com/cer/fileprintauth.ctf";
                jsons.printer = printSelect.value;    //打印机名称，为空或者不指定，则通过缺省打印机打印。
                jsonsList.push(jsons);
            printWorld.Direct(jsonsList);
        }
    }
    async getpage() {

        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        if (this.creationTime.length > 0) {
            this.pagerequest.beginTime = this.creationTime[0];
        }
        if (this.creationTime.length > 1) {
            this.pagerequest.endTime = this.creationTime[1];
        }
        if (this.deductionTime.length > 0) {
            this.pagerequest.deductionBeginTime = this.deductionTime[0];
        }
        if (this.deductionTime.length > 1) {
            this.pagerequest.deductionEndTime = this.deductionTime[1];
        }

        await this.$store.dispatch({
            type: 'backoverseasreturnhandle/getAll',
            data: this.pagerequest
        })
    }
    get pageSize() {
        return this.$store.state.backoverseasreturnhandle.pageSize;
    }
    get totalCount() {
        return this.$store.state.backoverseasreturnhandle.totalCount;
    }
    get currentPage() {
        return this.$store.state.backoverseasreturnhandle.currentPage;
    }
    async operationData(name: any, data: any) {
        var _this: any = this;
        if (name == '确认拒收') {
            await this.$store.dispatch({
                type: 'backoverseasreturnhandle/editConfirmRejection',
                data: { Id: data.id, HandleStatus: data.handleStatus, HandleType: data.handleType }
            });
        }
        else if (name == "确认退货") {
            this.$store.state.returnrejection.confirmReturnInfo = data;
            this.returnHandleModalShow = true;
        }
        else if (name == "处理失败") {
            this.$store.state.returnrejection.processFaileInfo = data;
            this.processFailureModalShow = true;
        } else if (name == '退货撤回') {
            this.$Modal.confirm({
                title: "退货撤回", content: "确认撤销退货快递单号为" + data.returnNo + "的已退货", onOk: async () => {
                    await this.$store.dispatch({
                        type: 'backoverseasreturnhandle/cancleReturn',
                        data: { id: data.id }
                    });
                    _this.$previewRefresh();
                    this.getpage();
                }
            });
        }
        else if (name == "扣除快递费") {
            this.$store.state.returnrejection.confirmReturnInfo = data;
            this.expressCostHandleModalShow = true;
        }
        else if (name == "扣费撤回") {
            await this.$store.dispatch({
                type: 'backoverseasreturnhandle/deductionReturn',
                data: { id: data.id }
            });
            _this.$previewRefresh();
            this.getpage();

        }
        else if (name == "撤销") {
            await this.$store.dispatch({
                type: 'backoverseasreturnhandle/processCancelFaile',
                data: { id: data.id }
            });
        }
        else if (name == "添加备注") {
            this.$store.state.returnrejection.id = data.id;
            this.addRemarkModalShow = true;
        }
        if (name != "退货撤回") {

            _this.$previewRefresh();
            this.getpage();
        }
    }
    columns = [{
        type: 'selection',
        width: 50,
        align: 'center',
        fixed: 'left',
    }, {
        title: '处理类型',
        width: 60,
        fixed: 'left',
        key: 'handleType',
        render: (h: any, params: any) => {
            return h('span', Enums.HandleType.filter(function (item) { return item.value == params.row.handleType })[0].name);
        }
    },
    {
        title: '订单类型',
        width: 60,
        key: 'orderType',
        render: (h: any, params: any) => {
            return h('span', Enums.WarehouseOrderType.filter(function (item) { return item.value == params.row.orderType })[0].name);
        }
    }, {
        title: '是否虾皮退回',
        key: 'isShopeeReturn',
        width: 60,
        render: (h: any, params: any) => {
            return h('span', params.row.isShopeeReturn ? this.L('是') : this.L('否'))
        }
    },

    {
        title: '虾皮退回件录入时间',
        key: 'shopeeReturnTime',
        width: 150,
        render: (h: any, params: any) => {
            if (params.row.shopeeReturnTime == null) {
                return "";
            }
            else {
                return h('span', DateUtils.formatLongDate(new Date(params.row.shopeeReturnTime)));
            }

        }
        }
        , {
            title: '退货图片',
            key: 'imageGuid',
            width: 150,
            render: (h: any, params: any) => {
                if (params.row.imageGuid) {
                    var datas = { goodsImageGuid: params.row.imageGuid, urls: null };
                    this.$store.commit('backlogistics/getGoodsImgUrl', datas);
                    var urls = datas.urls;
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: urls,
                            preview: params.row.id + "_",
                            "preview-text": params.row.imageGuid
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
        },
    {
        title: '备注',
        width: 250,
        key: 'reMark',
    },
    {
        title: '用户编码',
        key: 'userCode',
        width: 85,
    },
    {
        title: '快递接收时间',
        key: 'signForTime',
        width: 150,
        render: (h: any, params: any) => {
            if (params.row.signForTime == null) {
                return "";
            }
            else {
                return h('span', DateUtils.formatLongDate(new Date(params.row.signForTime)));
            }

        }
    },
    {
        title: '包裹状态',
        width: 90,
        key: 'packageStatus',
        render: (h: any, params: any) => {
            var data = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus });
            var name = '';
            if (data.length > 0) {
                name = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == params.row.packageStatus })[0].name;
            }
            return h('span', name,
            )
        }
    },
    {
        title: '入库人',
        key: 'intoHouseName',
        width: 120,
    },


    {
        title: '签收状态',
        width: 100,
        key: 'receiveStatus',
        render: (h: any, params: any) => {
            return h('span', Enums.ShipmentReceiveStatus.filter(function (item) { return item.value == params.row.receiveStatus })[0].name);
        }
    },

    {
        title: '快递单号',
        key: 'shipment',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.shipment + (params.row.shelfNumber != null ? "-" + params.row.shelfNumber : ""));
        }
    },
    {
        title: '收件人',
        key: 'recipientName',
        width: 120,
    },
    {
        title: '收货地址',
        key: 'receiptAddress',
        width: 200,
    },
    {
        title: '手机号',
        key: 'phone',
        width: 120,
    },
    {
        title: '固话',
        key: 'receiptPhone',
        width: 120,
    },

    {
        title: '扣费状态',
        width: 90,
        key: 'deductionType',
        render: (h: any, params: any) => {
            if (params.row.handleStatus == 1) {
                return h('span', Enums.DeductionType.filter(function (item) { return item.value == params.row.deductionType })[0].name);
            }
            else {
                return h('span', "");
            }

        }
    },




    {
        title: '仓库备注',
        key: 'warehouseRemark',
        width: 150,
    },
    {
        title: '收件人信息',
        key: 'recipientInfo',
        width: 150,
    },
    {
        title: '退货单号',
        key: 'returnNo',
        width: 120,
    },
    {
        title: '快递公司',
        key: 'expressCompany',
        width: 150,
    }, {
        title: '退货快递公司',
        key: 'returnExpressCompany',
        width: 150,
    }, {
        title: '快递费',
        key: 'expressCost',
        width: 150,
    },
    {
        title: '处理备注',
        key: 'processReMark',
        width: 150,
    },
    {
        title: '仓库名称',
        key: 'storeName',
        width: 150,
    },
    {
        title: '创建时间',
        key: 'createTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
        }
    }, {
        title: '扣费处理时间',
        key: 'deductionTime',
        width: 150,
        render: (h: any, params: any) => {
            if (params.row.deductionTime != null) {
                return h('span', DateUtils.formatLongDate(new Date(params.row.deductionTime)));
            }
            else {
                return "";
            }

        }
    }, {
        title: '撤销时间',
        key: 'revokedTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.revokedTime ? DateUtils.formatLongDate(new Date(params.row.revokedTime)) : '');
        }
    }, {
        title: '拒收时间',
        key: 'rejectionTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.rejectionTime ? DateUtils.formatLongDate(new Date(params.row.rejectionTime)) : '');
        }
    }, {
        title: '退货时间',
        key: 'returnTime',
        width: 150,
        render: (h: any, params: any) => {
            return h('span', params.row.returnTime ? DateUtils.formatLongDate(new Date(params.row.returnTime)) : '');
        }
    }, {
        title: '处理状态',
        width: 80,
        key: 'handleStatus',
        fixed: 'left',
        render: (h: any, params: any) => {
            return h('span', Enums.HandleStatus.filter(function (item) { return item.value == params.row.handleStatus })[0].name);
        }
    }, {
        title: '操作',
        width: 100,
        fixed: 'right',
        key: 'id',
        render: (h: any, params: any) => {
            var _this = this;
            var menu = [];
            var a = Enums.HandleStatus.filter(function (item) { return item.value == params.row.handleStatus })[0].name == "待处理";
            var b = Enums.HandleType.filter(function (item) { return item.value == params.row.handleType })[0].name == "拒收";
            var c = Enums.HandleType.filter(function (item) { return item.value == params.row.handleType })[0].name == "退货";
            var d = Enums.HandleStatus.filter(function (item) { return item.value == params.row.handleStatus })[0].name == "已退货";
            var e = Enums.HandleStatus.filter(function (item) { return item.value == params.row.handleStatus })[0].name == "处理失败";
            var f = Enums.DeductionType.filter(function (item) { return item.value == params.row.deductionType })[0].name == "未扣费";
            var g = Enums.DeductionType.filter(function (item) { return item.value == params.row.deductionType })[0].name == "已扣费";
            if (a && b) {
                menu.push("确认拒收");
            }
            if (a && c) {
                menu.push("确认退货");
            }
            if (a) {
                menu.push("处理失败");
            }
            if (d && c) {
                menu.push("退货撤回");
            }
            if (d && f) {
                menu.push("扣除快递费");
            }
            if (g) {
                menu.push("扣费撤回");
            }
            if (e) {
                menu.push("撤销");
            }
            if (a || d || f || g) {
                menu.push("添加备注");
            }
            return h('div',[
            h('Dropdown', {
                props: {
                    transfer: true,
                    trigger: 'click',
                },
                on: {
                    'on-click': (name) => {
                        _this.operationData(name, params.row);
                        
                    }
                }

            }, [
                h('Button',
                    {
                        domProps: {
                            innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                        },
                        props: {
                            type: 'primary',
                        }

                    }),
                h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                    return h('DropdownItem', { props: { name: item } }, item)
                }),
                 
                )]),
                h('Button', {
                    props: {
                        type: 'primary',
                        size: 'small',
                    },
                    style: {
                        marginTop: '5px',
                        height: '30px',
                        width: '68px',
                    },
                    on: {
                        click: () => {
                            var data = params.row;
                            var _this = this;
                            //var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                            _this.printingImage(params.row);
                        }
                    }
                }, "打印PDF"),
                //h('Button', {
                //    props: {
                //        type: 'primary',
                //        size: 'small',
                //    },
                //    style: {
                //        marginTop: '5px',
                //        height: '30px',
                //        width: '68px',
                //    },
                //    on: {
                //        click: () => {
                //            var data = params.row;
                //           // var packageStatus = Enums.WarehouseOrderPackageStatus.filter(function (item) { return item.value == data.packageStatus })[0].name;
                //            _this.Txm(params.row);
                //        }
                //    }

                //}, "查看图片"),
            ]);
        }
    }]
    async created() {
        this.getpage();
        this.getData();
    }
}
